export interface Media {
  code?: string;
  mime: string;
  altText: string;
  url: string;
  format?: string;
  width?: number;
  height?: number;
}

export enum ImageFetchPriority {
  HIGH = 'high',
  LOW = 'low',
  AUTO = 'auto',
}
